import { render, staticRenderFns } from "./courseTabList.vue?vue&type=template&id=0ad369fe&scoped=true&"
import script from "./courseTabList.vue?vue&type=script&lang=js&"
export * from "./courseTabList.vue?vue&type=script&lang=js&"
import style0 from "./courseTabList.vue?vue&type=style&index=0&id=0ad369fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad369fe",
  null
  
)

export default component.exports